
import Orders from "./Order";

function Order() {
    return     <Orders/> 
         
}

export default Order;
